<template>
    <!--表单-->
    <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="1200px" top="5vh">
        <el-form :model="formData" :rules="formRules" ref="dataForm" :inline="true" label-width="90px">
            <el-form-item label="团队id" style="width:100%">
                <div>{{formData.team.team_number}}</div>
            </el-form-item>
            <el-form-item label="团队名称" prop="team.name" style="width:100%">
                <el-input v-model="formData.team.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="管理区域" prop="team.area" style="width:100%">
                <el-input v-model="formData.team.area" auto-complete="off"></el-input>
            </el-form-item>

        <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:60px 0 30px;" /> 
        
            <h3 class="el-dialog__title">队员配置</h3>
            
            <div class="newAddTeamUser" v-for="(item, index) in formData.user_arr" :key="index">
                <el-form-item label="名字" :prop="'user_arr.' + index + '.realname'" :rules="{required: true, message: '请输入队员名字', trigger: 'blur'}">
                    <el-input v-model="item.realname"></el-input>
                </el-form-item>
                <el-form-item label="身份" :prop="'user_arr.' + index + '.is_team'" :rules="{required: true, message: '请选择队员的身份', trigger: 'blur'}">
                    <el-select v-model="item.is_team" value-key="is_team" placeholder="请选择" style="width:100px">
                        <el-option label="队长" value="1"></el-option>
                        <el-option label="队员" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" :prop="'user_arr.' + index + '.tel'" :rules="{required: true, message: '请输入手机号码', trigger: 'blur'}">
                    <el-input v-model="item.tel" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" :prop="'user_arr.' + index + '.idcard'" :rules="{required: true, message: '请输入身份证号码', trigger: 'blur'}">
                    <el-input v-model="item.idcard" maxlength="18"></el-input>
                </el-form-item>
                <el-form-item v-if="index > 0">
                    <el-button type="text" @click.native="teamUserItmeDel(item, index)" icon="el-icon-close"></el-button>
                </el-form-item>
            </div>

        </el-form>
        <div class="addTeamUserBut">
            <el-button type="primary" @click.native="newTeamUserItme" icon="el-icon-plus" plain>添加更多成员</el-button>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" style="width:200px">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {apiAddXteamSave} from "../../api/views/patrol"
const addTeamJson = {    
    "team":{//团队信息
        "team_number": "",//团队id
        "name": "",//团队名称
        "area": ""//团队管理区域
    },
    "user_arr":{//队员信息
        "0":{
            "realname":"",//姓名
            "is_team":"1",//0，队员，1队长
            "tel":"",//联系方式
            "idcard":""//身份证
        }
    }
}
const addTeamUserJson = {    
    "team":{
        "t_id": "6"//团队数据表id
    },
    "user_arr":{//添加得队员信息
        "0":{
            "realname":"维保13",//队员名称
            "is_team":"0",//0.队员 1.队长
            "tel":"130000099d",//手机号
            "idcard":"45f6464ddd684"//身份证号
            
        }
    }
}

const editTeamUserJson = {
    id:'', //队员数据表id
    realname: '', //姓名
    is_team: '', //0.队员 1.队长
    tel: '', //手机号
    idcard: '' //身份证号
}
const formDataUserJson = [{
    "realname":"",
    "is_team":"1",
    "tel":"",
    "idcard":""
}]
export default {
  name: "addEditSmall",
  data() {
    return {
        formData: {    
            "team":{
                "team_number": "",
                "name": "",
                "area": ""
            },
            "user_arr": []
        },
        formDataMap:{
            addTeam: addTeamJson,
            addTeamUser: addTeamUserJson,
            editTeamUser: editTeamUserJson
        },
        formMap: {
            addTeam: "团队信息", //新建巡查团队
            addTeamUser: "团队信息", //新建巡查队员
            editTeamUser: "团队信息" //编辑巡查队员
        },
        formName: null,

        formLoading: false,
        formVisible: false,
        formRules: {},

        
        roles: [],
        teamUserArray:{
            "realname":"",
            "is_team":"",
            "tel":"",
            "idcard":"",
            newTeamUserArr: []
        },
        addRules: {
            team: {
                name: [{ required: true, message: "请输入团队名称", trigger: "blur" }],
                area:[{ required: true, message: "请输入团队管理区域", trigger: "blur" }]
            },
            user_arr:{
                realname:[{ required: true, message: "请输入姓名", trigger: "blur" }],
                is_team:[{ required: true, message: "请输入选择", trigger: "blur" }],
                tel:[{ required: true, message: "请输入手机号", trigger: "blur" }],
                idcard:[{ required: true, message: "请输入身份证号", trigger: "blur" }]
            }
        },
    };
  },
  props: {
    show: {
        type: Boolean,
        default: ''
    },
    type: {
        type: String,
        default: ''
    },
  },
  watch:{
    show(boo,olds){
        // this.formVisible = this.show
        console.log(this.show)
        if(this.show){
            this.handleForm(null, null)
        }
    }
  },
  components: {},
  created() {
      console.log(this.formVisible)
      if(this.formVisible){
          this.handleForm(null,null)
      }
  },
  mounted() {
      this.formName = this.type
      this.formVisible = this.show
  },
  methods: {
    // 隐藏表单
    hideForm() {
        // 更改值
        this.formVisible = !this.formVisible;
        this.$emit("onChange",this.formVisible)
        // 清空表单
        this.$refs["dataForm"].resetFields();
        this.formData.user_arr = Array.from(formDataUserJson)
        return true;
    },
    // 显示表单
    handleForm(index, row) {
        this.formVisible = true;
        // this.formData = Object.assign({}, this.formDataMap[this.formName])
        this.formData.user_arr = Array.from(formDataUserJson)
        if (row !== null) this.formData = Object.assign({}, row)
        console.log(this.formData)
        this.formRules = this.addRules;
        this.formData.team.team_number = 'XC' + Math.floor(Math.random() * (1000000 - 1)) + 1
        
        // 清空验证信息表单
        if (this.$refs["dataForm"]) {
            this.$refs["dataForm"].clearValidate();
        }
    },
    formSubmit() {
        const that = this
        this.$refs["dataForm"].validate(valid => {
            if (valid) {
                let newObj = {}, data = {}, newFormData = JSON.parse(JSON.stringify(this.formData))
                newFormData.user_arr.forEach((item,index) => {
                    newObj[index] = item
                })
                newFormData.user_arr = newObj
                data = newFormData
                apiAddXteamSave(data, this.formName).then(res => {
                    that.formLoading = false;
                    if (res.code == 0) {
                        that.$message({
                            message: "操作成功",
                            type: "success"
                        });
                        // 刷新表单
                        that.$refs["dataForm"].resetFields();
                        that.hideForm()
                        that.$parent.getList({page: 1})
                    } else {
                        that.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
            }
        })
    },
    newTeamUserItme() {
        console.log(this.formData.user_arr)
        let formDataUserArr = this.formData.user_arr
        formDataUserArr.push({
            idcard: "",
            is_team: "0",
            realname: "",
            tel: ""
        })
    },
    teamUserItmeDel(item, index){
        this.formData.user_arr.splice(index, 1)
    },
  }
};
</script>
<style lang="scss" scoped>
  .app-container h2{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 28px;
  }
  .app-container h3{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 22px;
  }
  .app-container h3.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}
  .dialog-footer{
    margin-top: 0;
    width: 100%;
    text-align: center;
  }
  .addTeamUserBut{
      text-align: center;
      margin: 40px 0;
  }
</style>
